import React from 'react'

function QuizSubmittedIllustration() {
  return (
    <svg
      viewBox="0 0 1170 825"
      version="1.1"
      xmlns="http://www.w3.org/2000/svg"
    >
      <defs>
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-1"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-3"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-5"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-7"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-9"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-11"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-13"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-15"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-17"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-19"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-21"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-23"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-25"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-27"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-29"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-31"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-33"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-35"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-37"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-39"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-41"
        />
        <path
          d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
          id="path-43"
        />
      </defs>
      <g
        id="Artboard"
        stroke="none"
        strokeWidth="1"
        fill="none"
        fillRule="evenodd"
      >
        <g id="Group-11" transform="translate(11.047684, 11.000000)">
          <path
            d="M69.7471128,790 C57.5788998,736.818639 77.3114758,679.587898 128.94484,618.307776 C206.394885,526.387593 230.457839,505.463286 195.300486,411.574863 C160.143133,317.686441 77.5974908,120.580215 254.151983,33.1948871 C430.706474,-54.1904411 521.700869,55.2858378 614.430175,84.4218073 C707.159481,113.557777 971.129406,184.960095 1072.80047,346.02834 C1174.47154,507.096586 1091.25602,504.99548 1072.80047,627 C1054.34493,749.00452 1115.03672,790 1040.285,790 C990.450526,790 666.937894,790 69.7471128,790 Z"
            id="Path-2"
            fill="#DFF1F1"
            fillRule="nonzero"
          />
          <g
            id="Group-13"
            transform="translate(600.341042, 431.853238) rotate(-7.000000) translate(-600.341042, -431.853238) translate(238.341042, 106.353238)"
          >
            <path
              d="M20.421354,584.658296 L0,631.745233 L0,631.745233 L165.714164,651 L172.838415,615.304772 C174.027472,609.34714 170.161778,603.553604 164.204147,602.364547 C164.147813,602.353304 164.091392,602.342502 164.03489,602.332142 L32.4968561,578.215397 C27.4630019,577.292469 22.4576424,579.963084 20.421354,584.658296 Z"
              id="Path-6"
              stroke="#252B4C"
              strokeWidth="2"
              fill="#00B8A5"
              fillRule="nonzero"
            />
            <path
              d="M66.987736,389.333349 L173.690583,243 L173.690583,243 C185.919158,277.573895 193.547898,307.613422 196.576803,333.118582 C199.605708,358.623741 200.472177,400.118875 199.176211,457.603983 L201.437001,492.792804 C202.043386,502.231095 196.709406,511.049011 188.068263,514.893449 L180.391712,518.308741 C176.232441,520.159197 173.344128,524.050481 172.777219,528.567375 L166.291032,580.246596 C165.740816,584.63048 161.740938,587.738283 157.357054,587.188068 C157.189602,587.167052 157.022857,587.140741 156.85707,587.109177 L51.5067937,567.051631 C47.5183358,566.292272 44.7311738,562.665665 45.0238417,558.616126 L54.8664659,422.427331 C55.7299961,410.478979 59.9296763,399.012842 66.987736,389.333349 Z"
              id="Path-7"
              stroke="#252B4C"
              strokeWidth="2"
              fill="#FFFFFF"
              fillRule="nonzero"
            />
            <g id="Group-44" transform="translate(23.604008, 0.000000)">
              <path
                d="M6,0 L694,0 C697.313708,0 700,2.6862915 700,6 L700,436 C700,439.313708 697.313708,442 694,442 L6,442 C2.6862915,442 0,439.313708 0,436 L0,6 C0,2.6862915 2.6862915,0 6,0 Z"
                id="Rectangle"
                fill="#B2CECE"
                fillRule="nonzero"
              />
              <path
                d="M210.159008,6 L317.165797,6 C320.007524,6 322.459516,7.99351079 323.039502,10.7754224 L327,29.7720117 L327,29.7720117 L201,30 L204.244539,10.9905183 C204.736524,8.10801852 207.234824,6 210.159008,6 Z"
                id="Rectangle-Copy-29"
                fill="#FFFFFF"
                fillRule="nonzero"
                opacity="0.251408067"
              />
              <path
                d="M336.159008,6 L443.165797,6 C446.007524,6 448.459516,7.99351079 449.039502,10.7754224 L453,29.7720117 L453,29.7720117 L327,30 L330.244539,10.9905183 C330.736524,8.10801852 333.234824,6 336.159008,6 Z"
                id="Rectangle-Copy-30"
                fill="#FFFFFF"
                fillRule="nonzero"
                opacity="0.251408067"
              />
              <g
                id="Mask"
                transform="translate(0.000000, 6.000000)"
                fill="#FFFFFF"
                fillRule="nonzero"
              >
                <path
                  d="M190.747196,0 C193.578174,0 196.023969,1.9787936 196.614987,4.7473913 L200.552145,23.1908353 L200.56,23.567 L700,23.5675676 L700,430 C700,433.313708 697.313708,436 694,436 L6,436 C2.6862915,436 0,433.313708 0,430 L0,23.5675676 L74.688,23.567 L74.692191,23.4132497 L77.9158977,4.9670777 C78.41776,2.09540236 80.9111193,0 83.8263183,0 L190.747196,0 Z"
                  id="path-1"
                />
              </g>
              <g
                id="Rectangle-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-2" fill="white">
                  <use xlinkHref="#path-1" />
                </mask>
                <g id="path-1" />
                <rect
                  id="Rectangle"
                  fill="#F2F8F8"
                  fillRule="nonzero"
                  mask="url(#mask-2)"
                  x="86"
                  y="10"
                  width="45"
                  height="7"
                  rx="3.5"
                />
              </g>
              <g
                id="Rectangle-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-4" fill="white">
                  <use xlinkHref="#path-3" />
                </mask>
                <g id="path-3" />
                <rect
                  id="Rectangle"
                  fill="#F2F8F8"
                  fillRule="nonzero"
                  mask="url(#mask-4)"
                  x="22"
                  y="43"
                  width="660"
                  height="21"
                  rx="10.5"
                />
              </g>
              <g id="Oval-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-6" fill="white">
                  <use xlinkHref="#path-5" />
                </mask>
                <g id="path-5" />
                <circle
                  id="Oval"
                  fill="#00B8A5"
                  fillRule="nonzero"
                  mask="url(#mask-6)"
                  cx="26"
                  cy="10"
                  r="4"
                />
              </g>
              <g
                id="Oval-Copy-5-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-8" fill="white">
                  <use xlinkHref="#path-7" />
                </mask>
                <g id="path-7" />
                <circle
                  id="Oval-Copy-5"
                  fill="#00B8A5"
                  fillRule="nonzero"
                  mask="url(#mask-8)"
                  cx="39"
                  cy="10"
                  r="4"
                />
              </g>
              <g
                id="Oval-Copy-6-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-10" fill="white">
                  <use xlinkHref="#path-9" />
                </mask>
                <g id="path-9" />
                <circle
                  id="Oval-Copy-6"
                  fill="#00B8A5"
                  fillRule="nonzero"
                  mask="url(#mask-10)"
                  cx="52"
                  cy="10"
                  r="4"
                />
              </g>
              <g id="Path-36-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-12" fill="white">
                  <use xlinkHref="#path-11" />
                </mask>
                <g id="path-11" />
                <line
                  x1="183"
                  y1="10"
                  x2="187"
                  y2="14"
                  id="Path-36"
                  stroke="#EEEDED"
                  strokeLinecap="round"
                  mask="url(#mask-12)"
                />
              </g>
              <g id="Path-37-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-14" fill="white">
                  <use xlinkHref="#path-13" />
                </mask>
                <g id="path-13" />
                <line
                  x1="187"
                  y1="10"
                  x2="183"
                  y2="14"
                  id="Path-37"
                  stroke="#EEEDED"
                  strokeLinecap="round"
                  mask="url(#mask-14)"
                />
              </g>
              <g id="Path-36-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-16" fill="white">
                  <use xlinkHref="#path-15" />
                </mask>
                <g id="path-15" />
                <line
                  x1="311"
                  y1="10"
                  x2="315"
                  y2="14"
                  id="Path-36"
                  stroke="#BED3D3"
                  strokeLinecap="round"
                  mask="url(#mask-16)"
                />
              </g>
              <g id="Path-37-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-18" fill="white">
                  <use xlinkHref="#path-17" />
                </mask>
                <g id="path-17" />
                <line
                  x1="315"
                  y1="10"
                  x2="311"
                  y2="14"
                  id="Path-37"
                  stroke="#BED3D3"
                  strokeLinecap="round"
                  mask="url(#mask-18)"
                />
              </g>
              <g id="Path-36-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-20" fill="white">
                  <use xlinkHref="#path-19" />
                </mask>
                <g id="path-19" />
                <line
                  x1="438"
                  y1="10"
                  x2="442"
                  y2="14"
                  id="Path-36"
                  stroke="#BED3D3"
                  strokeLinecap="round"
                  mask="url(#mask-20)"
                />
              </g>
              <g id="Path-37-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-22" fill="white">
                  <use xlinkHref="#path-21" />
                </mask>
                <g id="path-21" />
                <line
                  x1="442"
                  y1="10"
                  x2="438"
                  y2="14"
                  id="Path-37"
                  stroke="#BED3D3"
                  strokeLinecap="round"
                  mask="url(#mask-22)"
                />
              </g>
              <g id="Quiz-Clipped" transform="translate(0.000000, 6.000000)">
                <mask id="mask-24" fill="white">
                  <use xlinkHref="#path-23" />
                </mask>
                <g id="path-23" />
                <text
                  id="Quiz"
                  fill="#DDEBEB"
                  fillRule="nonzero"
                  mask="url(#mask-24)"
                  fontFamily="OpenSans-Bold, Open Sans"
                  fontSize="30"
                  fontWeight="bold"
                >
                  <tspan x="56.8671875" y="117">
                    Quiz
                  </tspan>
                </text>
              </g>
              <g
                id="Rectangle-Copy-39-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-26" fill="white">
                  <use xlinkHref="#path-25" />
                </mask>
                <g id="path-27" />
                <rect
                  id="Rectangle-Copy-39"
                  fill="#DDEBEB"
                  fillRule="nonzero"
                  mask="url(#mask-26)"
                  x="560.749547"
                  y="91.5963079"
                  width="89"
                  height="31"
                  rx="8"
                />
              </g>
              <g
                id="Rectangle-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-28" fill="white">
                  <use xlinkHref="#path-27" />
                </mask>
                <g id="path-39" />
                <rect
                  id="Rectangle"
                  fill="#DDEBEB"
                  fillRule="nonzero"
                  opacity="0.72476835"
                  mask="url(#mask-28)"
                  x="65"
                  y="161"
                  width="382"
                  height="15"
                  rx="7.5"
                />
              </g>
              <g
                id="Rectangle-Copy-35-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-30" fill="white">
                  <use xlinkHref="#path-29" />
                </mask>
                <g id="path-41" />
                <path
                  d="M72.6511282,251.193634 L258.23002,221.95701 C262.068734,221.352248 265.670884,223.973885 266.275646,227.812599 C266.29786,227.953601 266.315778,228.095246 266.329375,228.237338 C266.729622,232.419867 263.805189,236.191329 259.654744,236.845202 L74.0758525,266.081826 C70.2371379,266.686588 66.6349883,264.064952 66.0302264,260.226237 C66.0080125,260.085235 65.9900944,259.94359 65.976497,259.801498 C65.5762502,255.61897 68.5006834,251.847507 72.6511282,251.193634 Z"
                  id="Rectangle-Copy-35"
                  fill="#F2F8F8"
                  fillRule="nonzero"
                  opacity="0.72476835"
                  mask="url(#mask-30)"
                  transform="translate(166.152936, 244.019418) rotate(7.000000) translate(-166.152936, -244.019418) "
                />
              </g>
              <g
                id="Rectangle-Copy-9-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-32" fill="white">
                  <use xlinkHref="#path-31" />
                </mask>
                <g id="path-43" />
                <rect
                  id="Rectangle-Copy-9"
                  stroke="#252B4C"
                  strokeWidth="2"
                  opacity="0.172283794"
                  mask="url(#mask-32)"
                  x="65"
                  y="187"
                  width="212"
                  height="15"
                  rx="7.5"
                />
              </g>
              <g
                id="Rectangle-Copy-36-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-34" fill="white">
                  <use xlinkHref="#path-33" />
                </mask>
                <g id="path-45" />
                <path
                  d="M72.343418,281.153674 L323.675185,241.558156 C327.513899,240.953394 331.116049,243.575031 331.720811,247.413745 C331.743025,247.554747 331.760943,247.696392 331.77454,247.838484 C332.174787,252.021013 329.250354,255.792475 325.099909,256.446348 L73.7681424,296.041867 C69.9294277,296.646629 66.3272782,294.024992 65.7225162,290.186277 C65.7003023,290.045275 65.6823843,289.90363 65.6687868,289.761538 C65.2685401,285.57901 68.1929732,281.807547 72.343418,281.153674 Z"
                  id="Rectangle-Copy-36"
                  fill="#F2F8F8"
                  fillRule="nonzero"
                  opacity="0.72476835"
                  mask="url(#mask-34)"
                  transform="translate(198.721663, 268.800011) rotate(7.000000) translate(-198.721663, -268.800011) "
                />
              </g>
              <g
                id="Rectangle-Copy-38-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <mask id="mask-36" fill="white">
                  <use xlinkHref="#path-35" />
                </mask>
                <g id="path-47" />
                <rect
                  id="Rectangle-Copy-38"
                  stroke="#252B4C"
                  strokeWidth="2"
                  opacity="0.172283794"
                  mask="url(#mask-36)"
                  x="65"
                  y="319"
                  width="297"
                  height="15"
                  rx="7.5"
                />
              </g>
              <g
                id="Rectangle-Copy-37-Clipped"
                transform="translate(0.000000, 6.000000)"
              >
                <g id="Group-19-Clipped">
                  <mask id="mask-38" fill="white">
                    <use xlinkHref="#path-37" />
                  </mask>
                  <g id="path-49" />
                  <g id="Group-19" mask="url(#mask-38)">
                    <g
                      transform="translate(276.000000, 170.000000)"
                      id="Group-18"
                    >
                      <g transform="translate(0.020754, 0.511968)">
                        <g
                          id="Group-16"
                          transform="translate(74.108630, 75.084871) rotate(-7.000000) translate(-74.108630, -75.084871) translate(7.608630, 8.584871)"
                        >
                          <circle
                            id="Oval-Copy"
                            stroke="#00B8A5"
                            strokeWidth="2"
                            cx="66.0065284"
                            cy="65.8956732"
                            r="57.6707219"
                          />
                          <polygon
                            id="Combined-Shape"
                            fill="#FFFFFF"
                            fillRule="nonzero"
                            points="69.8973921 0 69.897 49.223 89.1310106 3.91312391 95.5650995 6.6442326 76.644 51.217 110.88495 16.9776026 115.827442 21.9200946 81.019 56.727 126.660668 38.2873131 129.27907 44.7680864 84.382 62.907 132.805045 62.9076529 132.805045 69.8973921 83.581 69.897 128.891921 89.1310106 126.160812 95.5650995 81.589 76.645 115.827442 110.88495 110.88495 115.827442 76.078 81.02 94.5177319 126.660668 88.0369586 129.27907 69.897 84.381 69.8973921 132.805045 62.9076529 132.805045 62.907 83.579 43.6740344 128.891921 37.2399455 126.160812 56.159 81.588 21.9200946 115.827442 16.9776026 110.88495 51.783 76.078 6.14437693 94.5177319 3.52597454 88.0369586 48.421 69.897 8.52651283e-14 69.8973921 8.56931264e-14 62.9076529 49.224 62.907 3.91312391 43.6740344 6.6442326 37.2399455 51.218 56.16 16.9776026 21.9200946 21.9200946 16.9776026 56.728 51.785 38.2873131 6.14437693 44.7680864 3.52597454 62.907 48.42 62.9076529 0"
                          />
                          <circle
                            id="Oval"
                            fill="#00B8A5"
                            fillRule="nonzero"
                            cx="66.2100506"
                            cy="66.2100506"
                            r="48.2100506"
                          />
                          <g
                            id="Submitted"
                            opacity="0.735101744"
                            transform="translate(33.000000, 57.000000)"
                            fill="#DDEBEB"
                            fillRule="nonzero"
                            fontFamily="OpenSans-Bold, Open Sans"
                            fontSize="13"
                            fontWeight="bold"
                          >
                            <text>
                              <tspan x="0" y="14">
                                Submitted
                              </tspan>
                            </text>
                          </g>
                        </g>
                      </g>
                    </g>
                  </g>
                </g>
                <g id="Path-9-Copy-Clipped">
                  <mask id="mask-40" fill="white">
                    <use xlinkHref="#path-39" />
                  </mask>
                  <g id="path-49" />
                  <path
                    d="M516.34813,355.994477 C505.458284,341.120361 478.2409,336.689842 475.530089,349.463003 C472.819277,362.236164 490.565693,374.112596 490.565693,382.220188 C490.565693,390.327781 501.219327,421.731017 512.925469,449.144855 C517.592809,460.074988 532.337578,512.141401 548.127454,542.205077 C555.202002,555.674905 566.820301,569.677514 582.982352,584.212903 L689.597429,565.98048 C685.74846,543.368792 684.303336,526.382452 685.262059,515.021459 C686.220782,503.660466 690.389572,488.370989 697.768429,469.153028 L711.428541,429.213958 C713.562529,419.856165 713.562529,412.619562 711.428541,407.504147 C709.294553,402.388732 703.86436,396.608539 695.137962,390.163568 C685.738678,383.776439 677.056689,376.253786 669.091996,367.595611 C661.127303,358.937435 650.66221,345.645878 637.696717,327.720938 C631.272901,323.034091 624.554523,319.306573 617.541584,316.538385 C610.528645,313.770197 599.008901,310.298658 582.982352,306.123767 L531.617792,277.940631 C524.613553,274.097528 515.820034,276.660095 511.976899,283.664317 C511.453073,284.619005 511.03872,285.629788 510.741715,286.677458 C510.741715,286.677458 510.741715,286.677458 510.741715,286.677458 C509.606348,290.682409 511.475153,297.164512 516.34813,306.123767 L516.34813,306.123767 L573.569718,348.949827 C580.062942,353.809517 585.94085,359.441089 591.073911,365.720439 C599.566429,376.109464 605.680853,384.257173 609.417184,390.163568 C614.250043,397.803357 616.958177,404.624081 617.541584,410.625741 C619.673122,425.410377 618.664535,434.759224 614.515823,438.67228 C610.367112,442.585335 599.855954,444.101887 582.982352,443.221933 C572.802224,441.428163 565.395565,438.460531 560.762375,434.319037 C556.129185,430.177543 551.1757,422.279778 545.901921,410.625741 L545.901921,410.625741 C540.533598,395.341766 536.564061,385.127316 533.993311,379.982389 C528.701317,369.391345 520.547828,361.730719 516.34813,355.994477 Z"
                    id="Path-9-Copy"
                    fill="#CADFDF"
                    fillRule="nonzero"
                    opacity="0.481944949"
                    mask="url(#mask-40)"
                  />
                </g>
                <g>
                  <mask id="mask-42" fill="white">
                    <use xlinkHref="#path-41" />
                  </mask>
                  <g id="path-49" />
                  <rect
                    id="Rectangle-Copy-37"
                    fill="#F2F8F8"
                    fillRule="nonzero"
                    opacity="0.172283794"
                    mask="url(#mask-42)"
                    x="65"
                    y="345"
                    width="375"
                    height="15"
                    rx="7.5"
                  />
                </g>
                <g id="Path-11-Copy-Clipped">
                  <mask id="mask-44" fill="white">
                    <use xlinkHref="#path-43" />
                  </mask>
                  <g id="path-49" />
                  <path
                    d="M85.3064516,437.188532 C105.563526,410.055813 119.012409,378.585516 125.653101,342.77764 C135.61414,289.065825 160.217661,298.604002 167.483769,307.234759 C174.749877,315.865516 176.002828,333.444621 170.369624,364.22328 C164.73642,395.001939 161.613397,439.060085 163.174909,453.377417 C164.73642,467.694749 166.327388,491.871762 157.51564,505.490323"
                    id="Path-11-Copy"
                    fill="#CADFDF"
                    fillRule="nonzero"
                    opacity="0.481944949"
                    mask="url(#mask-44)"
                  />
                </g>
              </g>
            </g>
          </g>
          <path
            d="M777.743019,439.892689 C766.853173,425.018573 739.635789,420.588054 736.924978,433.361215 C734.214166,446.134376 751.960582,458.010808 751.960582,466.1184 C751.960582,474.225993 762.614216,505.629229 774.320358,533.043067 C778.987698,543.9732 793.732467,596.039613 809.522343,626.103289 C815.948103,638.337835 826.50874,653.708103 841.204255,672.214095 C843.990076,675.722263 848.498025,677.386615 852.895182,676.530427 L940.995632,659.376052 C947.342539,658.140219 951.568999,652.097747 950.55311,645.711944 C947.135892,624.231565 945.837171,608.634141 946.656948,598.919671 C947.615671,587.558678 951.784461,572.269201 959.163318,553.05124 L972.82343,513.11217 C974.957418,503.754377 974.957418,496.517774 972.82343,491.402359 C970.689442,486.286944 965.259249,480.506751 956.532851,474.06178 C947.133566,467.674651 938.451578,460.151998 930.486885,451.493823 C922.522192,442.835647 912.057099,429.54409 899.091606,411.61915 C892.66779,406.932303 885.949412,403.204785 878.936473,400.436597 C871.923534,397.668409 860.40379,394.19687 844.377241,390.021979 L793.012681,361.838843 C786.008442,357.99574 777.214923,360.558307 773.371788,367.562529 C772.847962,368.517217 772.433609,369.528 772.136604,370.57567 C772.136604,370.57567 772.136604,370.57567 772.136604,370.57567 C771.001237,374.580621 772.870042,381.062724 777.743019,390.021979 L777.743019,390.021979 L834.964607,432.848039 C841.457831,437.707729 847.335739,443.339301 852.468799,449.618651 C860.961318,460.007676 867.075742,468.155385 870.812073,474.06178 C875.644932,481.701569 878.353066,488.522293 878.936473,494.523953 C881.068011,509.308589 880.059424,518.657436 875.910712,522.570492 C871.762,526.483547 861.250843,528.000099 844.377241,527.120145 C834.197113,525.326375 826.790454,522.358743 822.157264,518.217249 C817.524074,514.075755 812.570589,506.17799 807.29681,494.523953 L807.29681,494.523953 C801.928486,479.239978 797.95895,469.025528 795.3882,463.880601 C790.096206,453.289557 781.942717,445.628931 777.743019,439.892689 Z"
            id="Path-9"
            stroke="#252B4C"
            strokeWidth="2"
            fill="#FFFFFF"
            fillRule="nonzero"
            transform="translate(855.533598, 518.402258) rotate(-7.000000) translate(-855.533598, -518.402258) "
          />
          <path
            d="M850.990171,696.929951 L861.559036,767.412745 L861.559036,767.412745 L1038.85979,789.18254 L1006.7257,666.969794 C1004.98916,660.365373 998.438632,656.230394 991.729449,657.503507 L861.422849,682.230073 C854.561217,683.532114 849.954491,690.023095 850.990171,696.929951 Z"
            id="Path-10"
            stroke="#252B4C"
            strokeWidth="2"
            fill="#00B8A5"
            fillRule="nonzero"
            transform="translate(944.852324, 723.228116) rotate(-7.000000) translate(-944.852324, -723.228116) "
          />
          <path
            d="M349.059293,575.584187 C369.316367,548.451468 382.76525,516.981171 389.405942,481.173295 C399.36698,427.46148 423.970502,436.999657 431.23661,445.630414 C438.502718,454.261171 439.755669,471.840276 434.122465,502.618935 C428.489261,533.397594 425.366238,577.45574 426.92775,591.773072 C428.489261,606.090404 430.080229,630.267417 421.268481,643.885978"
            id="Path-11"
            stroke="#252B4C"
            strokeWidth="2"
            fill="#FFFFFF"
            fillRule="nonzero"
            transform="translate(393.350061, 541.402290) rotate(-7.000000) translate(-393.350061, -541.402290) "
          />
          <rect
            id="Rectangle"
            fill="#B2CECE"
            fillRule="nonzero"
            x="0"
            y="775.871867"
            width="1149"
            height="20"
            rx="10"
          />
          <g
            id="Group-15"
            transform="translate(838.287486, 473.262451) rotate(-6.000000) translate(-838.287486, -473.262451) translate(712.287486, 366.762451)"
            fillRule="nonzero"
          >
            <polygon
              id="Path-8"
              fill="#252B4C"
              points="0 0 2.65895954 11.6162338 28.7438191 41 46 20.5 13.2024338 1.59811329"
            />
            <path
              d="M45.8108809,20.814954 L28.5238898,41.4246219 C46.0824522,59.9472598 61.0241349,74.7789722 73.348938,85.919759 C85.6737411,97.0605458 105.185161,113.372104 131.883198,134.854432 L233.359442,212.1855 C234.576364,213.112869 236.2962,212.975878 237.350973,211.867561 L250.420902,198.134142 C251.563124,196.933936 251.516119,195.035022 250.315912,193.8928 C250.303821,193.881294 250.291634,193.869888 250.279353,193.858584 L154.429375,105.640774 L154.429375,105.640774 C128.673321,84.0766621 109.242591,68.1772604 96.137185,57.9425685 C83.0317788,47.7078766 66.2563441,35.3320051 45.8108809,20.814954 Z"
              id="Path-12"
              stroke="#252B4C"
              strokeWidth="2"
              fill="#00B8A5"
            />
          </g>
        </g>
      </g>
    </svg>
  )
}

export default QuizSubmittedIllustration
